import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-request',
  templateUrl: './support-request.component.html',
  styleUrls: ['./support-request.component.css']
})
export class SupportRequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
